import {CreateMsgType} from '../../../shared/link/link-usage-response';

export function simplePermissionOverlayMsg(
    resource: string,
    forWorkspace: boolean = false,
    action: 'create' | 'edit' | 'delete',
    failReason: CreateMsgType
): string {
    if (failReason === 'overQuota') {
        return `You have created the maximum allowed number of ${resource}.`;
    } else {
        return noPermissionMessage(resource, forWorkspace, action);
    }
}

function noPermissionMessage(
    resource: string,
    forWorkspace: boolean,
    action: 'create' | 'edit' | 'delete'
): string {
    resource = resource.replace('_', ' ');
    if (forWorkspace) {
        return `You are not allowed to ${action} ${resource} in this workspace.`;
    } else {
        return `You are not allowed to ${action} ${resource}.`;
    }
}
